// Accordion web component, with smooth animation and keyboard support
(() => {
  const template = document.createElement('template');
  template.innerHTML = `
    <style>
    :host {
      display: block;
    }
    
    .accordion-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      line-height: 17px;
      font-size: 14px;
      position: relative;
      padding: var( --header-padding , 0.8rem 1rem);
      background-color: var(--accordion-header-background);
    }
    .icon {
      display: block;
      position: relative;
    }
    .icon::after, .icon::before {
      content: '';
      display: block;
      width: 0.8rem;
      height: 0.1rem;
      position: absolute;
      right: 0px;
      top: 50%;
      transform: translateY(-50%);
      background-color: #707070;
      transition: transform 0.3s ease-in-out;
    }
    .icon::after {
      transform: translateY(-50%) rotate(90deg);
    }
     
    .accordion-header[aria-expanded="true"] .icon::after {
      transform: translateY(-50%) rotate(0deg);
    }
    .accordion-pannel {
      overflow: hidden;
      height: 0px;
      will-change: height;
    }
    </style>
    <div class="accordion">
      <div class="accordion-header" role="button" aria-expanded="false" tabindex="0">
        <slot name="header"></slot>
        <i class="icon"></i>
      </div>
      <div class="accordion-pannel">
        <slot name="pannel"></slot>
      </div>
    </div>
  `;

  class Accordion extends HTMLElement {

    constructor() {
      super();

      const { targetInput, value, open, header } = this.dataset;
      this.value = this.dataset.value;
      this.targetInput = this.dataset.targetInput;
      this.height = -1;


      this.attachShadow({ mode: 'open' });
      this.shadowRoot.appendChild(template.content.cloneNode(true));

      this.accordion = this.shadowRoot.querySelector('.accordion');
      this.accordionHeader = this.shadowRoot.querySelector('.accordion-header');
      this.accordionPannel = this.shadowRoot.querySelector('.accordion-pannel');

      if (this.classList.contains('fixed-height')) {
        this.height = this.accordionPannel.scrollHeight
      }
      


      this.init();

      

      setTimeout(() => {
        this.accordionPannel.style.transition = 'height 0.45s ease-in-out';
      }, 100);

      this.accordionHeader.addEventListener('click', this.toggleAccordion.bind(this));
      this.accordionHeader.addEventListener('keyup', this.toggleAccordion.bind(this));
      this.classList.remove('opacity-0')
      if (!this.classList.contains('filter-accordion') ) {
        window.addEventListener('click',(e) => {   
          if (this.contains(e.target)){
            // Clicked in box
          } else{
            this.setAccordionClosed()
          }
        });
      }

      if (open) {
        this.setAccordionOpen();
        this.accordionPannel.style.height = 'auto';
      }

      if(header){
        this.accordionHeader.remove();
        this.accordionPannel.style.height = 'auto';
      }
    }
    init() {

      const input = this.querySelector('.select__select')
      this.querySelectorAll(`[data-value]`).forEach((el) => {
        
        el.addEventListener('click', (e) => {
          e.preventDefault();
          this.value = e.target.dataset.value;
          input.value = e.target.dataset.value;
          // input.dispatchEvent(new Event('input'))
          input.closest('form').dispatchEvent(new Event('input'));
          if (!this.classList.contains('filter-accordion') ) {
            this.setAccordionClosed()
          }
          el.classList.add('selected');
      });
    });
    }
    setAccordionOpen() {
      this.accordionHeader.setAttribute('aria-expanded', 'true');
      this.accordionPannel.style.height = `${ (this.height > -1) ? this.height : this.accordionPannel.scrollHeight}px`
      this.classList.add('open')
      this.dispatchEvent(new Event("open"));
    }
    close() {
      this.setAccordionClosed();
    }

    setAccordionClosed() {
      this.accordionHeader.setAttribute('aria-expanded', 'false');
      this.accordionPannel.style.height = '0px'
      this.classList.remove('open');
      this.dispatchEvent(new Event("close"));
    }

    toggleAccordion(e) {
      const { locked: isLocked = false } = this.dataset;
      if (e.type === 'keyup' && e.code !== 'Enter' && e.code !== 'Space') return;
      if (isLocked === 'true') return;

      if (this.accordionHeader.getAttribute('aria-expanded') === 'true') {
        this.setAccordionClosed()
      } else {
        this.setAccordionOpen()
      }
    }
  }
  customElements.define('custom-select', Accordion);
})();
